import React from "react";
import "@fontsource/special-elite";
import ResetWrapper from "./src/components/reset-wrapper";

export const wrapPageElement = ({ element }) => {
    function importAll(r) {
        return r.keys().map(r);
    }

    const images = importAll(require.context('./src/images', true, /\.(png|jpe?g|svg)$/));

    images.forEach(image => {
        const img = new Image();
        img.src = image.default;
    });

    return <ResetWrapper>{element}</ResetWrapper>;
};